import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from '#/components/ui/carousel';

import type { SurfaceSlotV1 } from '~/api/v1/mall/surface/surface-name';
import { DATA_AREAS } from '~/constants/data-areas';
import { EventBannerItem, type EventBannerItemStyles } from '~/features/event-list';

type Props = {
  styles: EventBannerItemStyles;
  items: SurfaceSlotV1[];
};

export const SiteEventCarousel = (props: Props) => {
  const { styles, items } = props;

  return (
    <div data-area={DATA_AREAS.SITE_EVENT_CAROUSEL}>
      <Carousel
        className="md:mx-auto md:max-w-[var(--breakpoint-lg)] md:px-4"
        opts={{
          align: 'start',
          loop: false,
          dragFree: true,
        }}>
        <CarouselContent className="mr-2 ml-4 md:mr-0 md:ml-0">
          {items?.map((item: SurfaceSlotV1, index: number) => (
            <CarouselItem
              key={`${item.event_id}-${index}`}
              className="max-w-[176px] basis-[48%] pr-2 pl-0 md:mr-2.5 md:max-w-[216px] md:basis-[calc(20%-10px)] md:pr-0 lg:basis-1/5">
              <EventBannerItem styles={styles} surfaceSlot={item} />
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious button="kabuand" className="left-0 hidden h-12 w-12 md:block lg:-left-2" />
        <CarouselNext button="kabuand" className="right-0 hidden h-12 w-12 md:block lg:-right-2" />
      </Carousel>
    </div>
  );
};
